module.exports = __webpack_public_path__ + "static/media/hollow_bar_shotStrip.356fb6a7.svg";